import stringToNumber from "src/utils/stringToNumber";
import yup from "src/utils/yup/extensionMethods";

const GoalManagementFormSchema = (translate:Function,language:string) => yup.object().shape({
	goal:IGoalManagementSchema(translate,language),
	competitiveness:IGoalManagementSchema(translate,language)
		.when("$useCompetitiveness",(useCompetitiveness,schema) => useCompetitiveness ? schema.required("Insira os dados de competitividade"):schema.nullable().default(null)),
	compromise:IGoalManagementSchema(translate,language)
		.when("$useCompromise",(useCompromise,schema) => useCompromise ? schema.required("Insira os dados de compromisso"):schema.nullable().default(null))
});

const IGoalManagementSchema = (translate:Function,language:string) => yup.object().shape({
	iqc002Metadefault:yup.number()
		.transform((value,originalValue) => {
			if(!originalValue && originalValue!==0 && originalValue!=="0")
				return null;
			return typeof originalValue !== "string" ? value : stringToNumber(originalValue,language);
		})
		.typeError(translate("Campo está com valor incorreto")),
	values:yup.array()
		.of(IIqtbd004Schema(translate,language))
});

const IIqtbd004Schema = (translate:Function,language:string) => yup.object().shape({
	iqd001Valor:yup.number()
		.transform((value,originalValue) => {
			if(!originalValue && originalValue!==0 && originalValue!=="0")
				return null;
			return typeof originalValue !== "string" ? value : stringToNumber(originalValue,language);
		})
		.typeError(translate("Campo está com valor incorreto"))
		.required("Valor da meta é obrigatória")
});

export default GoalManagementFormSchema;
